export default {
  moneySymbol: '¥',
  form: {
    lightFilter: {
      more: '更に',
      clear: 'クリア',
      confirm: '確認',
      itemUnit: 'アイテム'
    }
  },
  tableForm: {
    search: '検索',
    reset: 'リセット',
    submit: '送信',
    collapsed: '拡大',
    expand: '折畳',
    inputPlaceholder: '入力してください',
    selectPlaceholder: '選択してください'
  },
  alert: {
    clear: 'クリア',
    selected: '選択した',
    item: 'アイテム'
  },
  pagination: {
    total: {
      range: 'レコード',
      total: '/合計',
      item: ' '
    }
  },
  tableToolBar: {
    leftPin: '左に固定',
    rightPin: '右に固定',
    noPin: 'キャンセル',
    leftFixedTitle: '左に固定された項目',
    rightFixedTitle: '右に固定された項目',
    noFixedTitle: '固定されてない項目',
    reset: 'リセット',
    columnDisplay: '表示列',
    columnSetting: '列表示設定',
    fullScreen: 'フルスクリーン',
    exitFullScreen: '終了',
    reload: '更新',
    density: '行高',
    densityDefault: 'デフォルト',
    densityLarger: '大',
    densityMiddle: '中',
    densitySmall: '小'
  },
  stepsForm: {
    next: '次へ',
    prev: '前へ',
    submit: '送信'
  },
  loginForm: {
    submitText: 'ログイン'
  },
  editableTable: {
    action: {
      save: '保存',
      cancel: 'キャンセル',
      delete: '削除',
      add: '追加'
    }
  },
  switch: {
    open: '開く',
    close: '閉じる'
  }
};